import MobileAccountSectionsList from './MobileAccountSectionsList';

export default MobileAccountSectionsList;
